import { render, staticRenderFns } from "./fl44-unknown-volume-download-purchase-pdf-button.vue?vue&type=template&id=0f73a258&"
import script from "./fl44-unknown-volume-download-purchase-pdf-button.vue?vue&type=script&lang=js&"
export * from "./fl44-unknown-volume-download-purchase-pdf-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f73a258')) {
      api.createRecord('0f73a258', component.options)
    } else {
      api.reload('0f73a258', component.options)
    }
    module.hot.accept("./fl44-unknown-volume-download-purchase-pdf-button.vue?vue&type=template&id=0f73a258&", function () {
      api.rerender('0f73a258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl44-unknown-volume/partials/fl44-unknown-volume-download-purchase-pdf-button.vue"
export default component.exports